export const GET_PROGRAMS = "GET_PROGRAMS";
export const GET_PROGRAM_BY_ID = "GET_PROGRAM_BY_ID";
export const UPDATE_PROGRAM = "UPDATE_PROGRAM";
export const DELETE_PROGRAM = "DELETE_PROGRAM";
export const CREATE_PROGRAM = "CREATE_PROGRAM";
